module.exports = __webpack_public_path__ + "img/in-progress-ico.48438de1.svg";